/* Shared shimmer-block loader. */
import React from "react";

function Block({ width, height }) {
  return (
    <div
      className="shimmer"
      style={{
        width: width || "100%",
        height: height || 14,
        borderRadius: 6,
        background: "linear-gradient(90deg, #f0efe8 0%, #e6e4da 50%, #f0efe8 100%)",
        backgroundSize: "200% 100%",
        animation: "skeletonShimmer 1.4s linear infinite",
        marginBottom: 8,
      }}
    />
  );
}

function LoadingSkeleton({ rows = 3, width, height }) {
  return (
    <div role="status" aria-live="polite" aria-busy="true">
      {Array.from({ length: rows }).map((_, i) => (
        <Block key={i} width={width} height={height} />
      ))}
      <style>{`@keyframes skeletonShimmer { 0% { background-position: 200% 0; } 100% { background-position: -200% 0; } }`}</style>
    </div>
  );
}

export { LoadingSkeleton };
export default LoadingSkeleton;
